// SubjectMultiSelectModal.tsx
import { Modal, Select, Typography, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { theme } from '../../theme';

export type SubjectOption = { value: string; label: string };

type Props = {
  open: boolean;
  title?: string;
  onCancel: () => void;
  onSubmit: (subjectIds: string[], name?: string) => Promise<void> | void;

  options: SubjectOption[];
  loading?: boolean;

  initialSelectedIds?: string[];

  showNameInput?: boolean;
  initialName?: string;
  nameLabel?: string;

  okText?: string;
  cancelText?: string;
};

export const SubjectMultiSelectModal: React.FC<Props> = ({
  open,
  title = 'Selectează discipline',
  onCancel,
  onSubmit,
  options,
  loading = false,
  initialSelectedIds = [],
  showNameInput = false,
  initialName = '',
  nameLabel = 'Nume subgrup',
  okText = 'Confirmă',
  cancelText = 'Anulează',
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [selected, setSelected] = useState<string[]>([]);
  const [name, setName] = useState<string>(initialName);

  useEffect(() => {
    if (!open) return;
    setName(initialName ?? '');
    setSelected(initialSelectedIds);
  }, [open, initialSelectedIds, initialName]);

  const handleOk = async () => {
    setSubmitting(true);
    try {
      
      await onSubmit(selected, showNameInput ? name : undefined);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      title={title}
      width={720}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose
      okButtonProps={{
        loading: submitting,
        style: { background: theme.secondColor, border: theme.secondColor, borderRadius: '10px' },
      }}
      cancelButtonProps={{
        style: { background: theme.green, border: theme.green, color: theme.white, borderRadius: '10px' },
      }}
    >
      {showNameInput && (
        <div style={{ marginBottom: 12 }}>
          <Typography.Text style={{ display: 'block', marginBottom: 6 }}>{nameLabel}</Typography.Text>
          <Input
            placeholder="Ex: Pachet opționale sem. 2"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={200}
          />
        </div>
      )}

      <Typography.Paragraph type="secondary" style={{ marginBottom: 8 }}>
        Selectează una sau mai multe discipline din listă.
      </Typography.Paragraph>

      <Select
        mode="multiple"
        loading={loading}
        options={options}
        value={selected}
        onChange={(vals) => setSelected((vals as string[]).map(String))}
        showSearch
        filterOption={(input, option) =>
          (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
        }
        optionLabelProp="label"
        placeholder="Alege disciplinele"
        style={{ width: '100%' }}
      />
    </Modal>
  );
};
